<i class="material-icons">delete</i>
<div class="space"></div>
<ng-container i18n>Deleted</ng-container>
